import { useRef, useState } from 'react';
import '../css/Navbar.css';

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const menuButton = useRef(null);
  const closeMenu = () => setMenuOpen(false);

  const handleKeyDown = (event) => {
    if (event.key === 'Escape' && menuOpen) {
      closeMenu();
      menuButton.current?.focus();
    }
  };

  return (
    <header className="site-header" onKeyDown={handleKeyDown}>
      <nav className="navbar wrap" aria-label="Main navigation">
        <a className="brand" href="#hero" onClick={closeMenu}>
          <span className="mark">S<span>3</span></span>
          <span className="brand-name">Stewart Software{' '}<br />Solutions</span>
        </a>
        <button
          className="menu"
          ref={menuButton}
          aria-expanded={menuOpen}
          aria-controls="nav-links"
          onClick={() => setMenuOpen(open => !open)}
        >
          Menu
        </button>
        <div className={`nav-links${menuOpen ? ' open' : ''}`} id="nav-links">
          <a href="#services" onClick={closeMenu}>Services</a>
          <a href="#stack" onClick={closeMenu}>Stack</a>
          <a href="#about" onClick={closeMenu}>About</a>
          <a href="#contact" className="nav-contact" onClick={closeMenu}>
            Let’s talk <span aria-hidden="true">↗</span>
          </a>
        </div>
      </nav>
    </header>
  );
}
